module.exports = __webpack_public_path__ + "static/media/partner-06.709b7427.jpg";